import { createGlobalState } from 'react-use';
import { useEffect } from 'react';
type ServiceProvidingLocationUpdateModalState = {
   dirty: {
      updateForm: boolean;
      usingOwnDataUpdateForm: boolean;
   };
};

const useServiceProvidingLocationUpdateModalState = createGlobalState<ServiceProvidingLocationUpdateModalState>({
   dirty: {
      updateForm: false,
      usingOwnDataUpdateForm: false,
   },
});

export const useServiceProvidingLocationUpdateModalDirtyState = (): boolean => {
   const [state] = useServiceProvidingLocationUpdateModalState();

   return Object.values(state.dirty).some(Boolean);
};

export const useServiceProvidingLocationUpdateModalDirtyStateUpdate = (
   key: keyof ServiceProvidingLocationUpdateModalState['dirty'],
   dirty: boolean
): void => {
   const [, setState] = useServiceProvidingLocationUpdateModalState();
   return useEffect(() => {
      setState((state) => ({
         dirty: {
            ...state.dirty,
            [key]: dirty,
         },
      }));
   }, [key, dirty, setState]);
};
